export default __webpack_public_path__ + "static/media/cruis.32661e7d.png";